/**
 * Codable — obrys C+A z loga (public/codable/logo.jpg).
 * Jen tahy (`currentColor`), stejné API jako lucide, ať sedí k tématu.
 */
import { createLucideIcon } from 'lucide-react';

export const CodableIcon = createLucideIcon('Codable', [
  ['path', { d: 'M14.2 5.8A7 7 0 1 0 13.8 18.2', key: 'c' }],
  ['path', { d: 'M10.6 18 15.8 4.2 21 18', key: 'a' }],
]);
